import moment, { Moment } from "moment";

const todayDate = moment();
const yesterdayDate = moment().subtract(1, "days");
const lastWeekDate = moment().subtract(1, "weeks");
const previous30DaysDate = moment().subtract(30, "days");
const startOfYearDate = moment().startOf("year");

const today = (threadDate: Moment): boolean => {
  return threadDate.isSame(todayDate, "day");
};
const yesterday = (threadDate: Moment): boolean => {
  return threadDate.isSame(yesterdayDate, "day");
};
const lastWeek = (threadDate: Moment): boolean => {
  return threadDate.isBetween(lastWeekDate, yesterdayDate, "day", "[)");
};
const previous30Days = (threadDate: Moment): boolean => {
  return threadDate.isBetween(previous30DaysDate, lastWeekDate, "day", "[)");
};
const currentYear = (threadDate: Moment): boolean => {
  return threadDate.isBetween(startOfYearDate, previous30DaysDate, "day", "[]");
};
const beforeCurrentYear = (threadDate: Moment): boolean => {
  return threadDate.isBefore(startOfYearDate, "day");
};

export const startOfDay = (date: Date): Date => {
  const newDate = new Date(date);
  newDate.setHours(0, 0, 0, 0);
  return newDate;
};

export const endOfDay = (date: Date): Date => {
  const newDate = new Date(date);
  newDate.setHours(23, 59, 59, 999);
  return newDate;
};

export const DateIs = {
  today,
  yesterday,
  lastWeek,
  previous30Days,
  currentYear,
  beforeCurrentYear,
};
